'use es6';

import { fromJS } from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import InitialFilterParams from '../constants/InitialFilterParams';
import { mergeGoodFiltersAndPage, resetNotApplicableFilters } from '../utils/utils';
var initialState = fromJS({
  goodFiltersAndPage: InitialFilterParams,
  numGoodsMatchingFilterCriteria: 0,
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  goods: []
});
export default function directoryDataReducer() {
  var directoryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.FILTERS_OR_PAGE_UPDATED:
      return directoryData.set('goodFiltersAndPage', mergeGoodFiltersAndPage(directoryData.get('goodFiltersAndPage'), resetNotApplicableFilters(directoryData.get('goodFiltersAndPage'), action.payload)));

    case ActionTypes.GOODS_REQUESTED_ON_PAGE_LOAD:
      if (action.error) {
        return directoryData.set('requestStatus', RequestStatusTypes.FAILED);
      }

      return directoryData.set('requestStatus', RequestStatusTypes.PENDING);

    case ActionTypes.GOODS_RECEIVED:
      return directoryData.merge({
        requestStatus: RequestStatusTypes.SUCCEEDED,
        numGoodsMatchingFilterCriteria: action.payload.total,
        goods: action.payload.result
      });

    default:
      return directoryData;
  }
}